import React, { useCallback, useMemo } from 'react'

import type {
  OfferItem,
  SingleVariantOfferItem,
  VariantItem,
} from '../../SelectProductsModal.types'
import { ProductsListItemInput } from '../ProductsListItemInput/ProductsListItemInput'
import { ProductsListItemOfferContent } from '../ProductsListItemOfferContent/ProductsListItemOfferContent'
import { ProductsListItemVariantContent } from '../ProductsListItemVariantContent/ProductsListItemVariantContent'
import { ProductsListItemSkeleton } from './ProductsListItem.skeleton'
import * as S from './ProductsListItem.styled'
import type { ProductsListItemProps } from './ProductsListItem.types'

export const ProductsListItem = ({
  item,
  mode,
  selectMode,
  multiple = false,
  disabled,
  disabledMessage,
  value,
  onSelect,
  onBulkSelect,
}: ProductsListItemProps) => {
  const selectable = multiple || !(selectMode === 'VARIANTS' && item.type === 'OFFER')

  const handleClick = useCallback(() => {
    if (!selectable) return
    if (!multiple && !disabled) {
      onSelect(item.id)(!value)
    }
  }, [selectable, multiple, disabled, onSelect, item.id, value])

  const input = useMemo(
    () => (
      <ProductsListItemInput
        multiple={multiple}
        selectMode={selectMode}
        item={item}
        value={value}
        disabled={disabled}
        onSelect={onSelect}
        onBulkSelect={onBulkSelect}
        disabledMessage={disabledMessage}
      />
    ),
    [multiple, selectMode, item, value, disabled, onSelect, onBulkSelect, disabledMessage],
  )

  const content = (
    <S.Container
      disabled={disabled}
      active={multiple ? !!value : value === item.id}
      selectable={selectable}
      onClick={handleClick}
    >
      {item.type === 'VARIANT' ? (
        <ProductsListItemVariantContent item={item as VariantItem} input={input} />
      ) : (
        <ProductsListItemOfferContent
          item={item as OfferItem | SingleVariantOfferItem}
          input={input}
          mode={mode}
        />
      )}
    </S.Container>
  )

  return multiple ? <S.Label htmlFor={item.id}>{content}</S.Label> : content
}

ProductsListItem.Skeleton = ProductsListItemSkeleton
